export function getFileExtension(filename: string) {
    const parts = filename.split('.');
    
    if (parts.length > 1) {
      return parts[parts.length - 1].toLowerCase();
    } else {
      return "";
    }
  }